module.exports = __webpack_public_path__ + "static/media/main_icon_vehicles.75bc11a9.svg";